
import userProfile from '../reducers/userProfile';
import appState from '../reducers/appState';
import rootReducer from '../reducers';
import { connectRouter } from 'connected-react-router'

export const reducers = (history) =>({
    userProfile: userProfile,
    appState: appState,
    rootReducer: rootReducer,
    router: connectRouter(history),
});

